import React from 'react'
import styles from './FJSpinLoading.module.less';

function FJSpinLoading({style = {}}) {
	return (
		<div className={styles.loading_box}>
			<svg style={style} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
				<circle className={styles.spin_rotate}
								cx="32"
								cy="32"
								fill="none"
								r="22"
								stroke="white"
								strokeLinecap="round"
								strokeWidth={12}
				> </circle>
			</svg>
		</div>
	);
}

export default FJSpinLoading;